<template>
  <div class="l-contents officeinfo" v-if="noticeList.length > 0">
    <div class="info-list">
      <div class="title1"><h2><img src="@/assets/img/common/icon-nav3_blue.svg" alt="" width="22" height="22">事務所だより</h2>
    </div>
    <ul class="news-list" v-for="notice in latestNoticeList" :key="notice.noticeId">
      <li>
        <a @click="goDetail(notice.noticeId)">
          <span v-if="notice.file" class="file"><img src="@/assets/img/common/icon-attch_on.svg" alt=""></span>
          <span v-else class="file"><img src="@/assets/img/common/icon-attch_off.svg" alt=""></span>
          <span class="date">{{ $dayjs(notice.fromDt).format("YYYY年MM月DD日") }}</span>
          <span class="text">{{ notice.title }}</span>
        </a>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      noticeList: [
        {
          file: {}
        }
      ],
    }
  },
  computed: {
    latestNoticeList() {
      return this.noticeList.slice(0, 3);
    },
  },
  created: function() {
    this.getLatestNoticeForOfficeList();
  },
  methods: {
    async getLatestNoticeForOfficeList() {
      let res = await this.$axios.post('/ld/api/notice/getLatestNoticeList', {
        page: 1,
        inPeriod: true,
        forOffice: true,
        deleteFlg: false,
      });
      if (res) {
        this.noticeList = res.data.noticeList.data;
      }
    },
    goDetail(noticeId) {
      this.$store.dispatch('portal/setNoticeId', noticeId);
      this.$router.push({ name: 'notice-detail' });
    },
  }
}

</script>
